import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EmptyState from "../components/Controls/EmptyState";
import LoadingState from "../components/Controls/LoadingState";

import WishListCard from "../components/WishListCard";
import { BaseAPI } from "../utils/Api";
import ErrorHandler from "../utils/ErrorHandler";
import { getItem } from "../utils/Helper";
import Notification from "../utils/Notification";

const WishList = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [wishList, setWishList] = useState([]);

  useEffect(() => {
    getMyWishList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMyWishList = () => {
    setLoading(true);
    BaseAPI.get("/dataset/wishlist/my", { headers: { Authorization: `Bearer ${getItem(localStorage, "at")}` } })
      .then((res) => {
        setWishList(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, navigate);
        } else {
          Notification("Something went wrong! Please check your internet", "error");
        }
      })
      .finally(() => setLoading(false));
  };

  const removeFromWishList = async (data) => {
    setWishList([...wishList.filter((el) => el.url_name !== data)]);
    await BaseAPI.post("/dataset/wishlist", { dataset_url: data }, { headers: { Authorization: `Bearer ${getItem(localStorage, "at")}` } })
      .then(() => {
        // setWishList([...wishList.filter((el) => el.url_name !== data)]);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          ErrorHandler(err?.response?.data?.message, navigate);
        } else {
          Notification("Something went wrong! Please check your internet", "error");
        }
      });
  };

  return (
    <>
      {loading ? (
        <LoadingState loading={loading} />
      ) : wishList.length > 0 ? (
        <>
          <Typography variant='h4' mt={2} mb={4} className='bold'>
            My Wishlist
          </Typography>

          <Grid container spacing={4}>
            {wishList?.map((el) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={el.url_name}>
                <WishListCard
                  url={el.url_name}
                  image={el.image}
                  category={el.category}
                  name={el.name}
                  price={el.price}
                  discount={el.discount}
                  rows={el.data_rows}
                  removeFromWishList={removeFromWishList}
                />
              </Grid>
            ))}
          </Grid>
        </>
      ) : (
        <EmptyState message='You have nothing in wishlist. Care to add some?' />
      )}
    </>
  );
};

export default WishList;
